// import config from 'config';
import { authHeader } from '../../_helpers';
import axios from 'axios';

export const countryService = {
    getCountryList
};

function getCountryList() {
    return axios.get(`/masters/country/list/`, { headers: authHeader() }).then(handleResponse)
        .then(response => {
            return response;
        });
}

function handleResponse(response) {
    if(response.status === 200) {
        if(response.seller_list){
            if(response.seller_list.length == 0){
                const error = 'No data to display';
                return Promise.reject(error);
            }
            return response;
        }
        return response;
    }
    return response;
}


// WEBPACK FOOTER //
// ./src/_services/sellers/countrylist.service.js